import { render, staticRenderFns } from "./CompanyService1.vue?vue&type=template&id=790c5495"
import script from "./CompanyService1.vue?vue&type=script&lang=js"
export * from "./CompanyService1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports